<div class="container-fluid py-3">
  <div class="d-flex justify-content-between align-items-center mb-3">
    <div>
      <h2><i class="bi bi-geo text-warning me-2"></i>{{ 'stations_map.title' | translate }}</h2>
      <p class="text-muted mb-0">{{ 'stations_map.subtitle' | translate }}</p>
    </div>
    <button *ngIf="!userLocation && !geolocationDenied" class="btn btn-outline-primary"
      (click)="requestUserLocation()">
      <i class="bi bi-crosshair me-2"></i>{{ 'stations_map.locate_me' | translate }}
    </button>
  </div>

  <div *ngIf="geolocationDenied" class="alert alert-warning small mb-3">
    <i class="bi bi-exclamation-triangle me-2"></i>{{ 'stations_map.geo_denied' | translate }}
  </div>

  <div *ngIf="dataReady && points.length === 0" class="empty-state card align-items-center">
    <i class="bi bi-map"></i>
    <h4>{{ 'stations_map.empty_title' | translate }}</h4>
    <p class="text-muted">{{ 'stations_map.empty_text' | translate }}</p>
  </div>

  <div class="row g-3" *ngIf="points.length > 0">
    <div [class.col-lg-8]="selectedStation" [class.col-12]="!selectedStation">
      <app-station-map
        [stations]="points"
        [userLocation]="userLocation"
        [clickableMarkers]="true"
        height="calc(100vh - 180px)"
        (stationClick)="onStationClick($event)">
      </app-station-map>
    </div>

    <div class="col-lg-4" *ngIf="selectedStation">
      <div class="card h-100">
        <div class="rep-card-header"><i class="bi bi-ev-station me-2"></i>{{ selectedStation.name }}</div>
        <div class="card-body">
          <div class="mb-2 text-muted small" *ngIf="selectedStation.__loc?.name">
            <i class="bi bi-geo-alt me-1"></i>{{ selectedStation.__loc.name }}
          </div>
          <div class="mb-2 small" *ngIf="selectedStation.__loc?.street || selectedStation.__loc?.city">
            {{ selectedStation.__loc?.street }} {{ selectedStation.__loc?.city }} {{ selectedStation.__loc?.zip }}
          </div>
          <div class="mb-3">
            <span class="badge badge-primary">{{ selectedStation.__st?.capacity_kwh || '?' }} kWh</span>
          </div>
          <button class="btn btn-accent w-100" (click)="reserveSelected()">
            <i class="bi bi-plus-circle me-2"></i>{{ 'stations_map.reserve_btn' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
